import React from 'react';
import { Redirect, Route } from 'react-router';
import useAuth from '../../hooks/useAuth';

const PrivateRoute = ({children, ...rest}) => {
    const {user,isLoad} =useAuth();
    if(isLoad){
        return <div className="spinner-border text-danger" role="status">
      </div>
    }
    return (
        <Route
        {...rest}
        render={({location})=>user.email? children: <Redirect
        
        to={{
            pathname: "/login",
            state: { from: location }
          }}

        ></Redirect>}
        >
            

        </Route>
    );
};

export default PrivateRoute;